module.exports = __webpack_public_path__ + "media/images/gallery/constellations/dir_layer_off-42997da3887b6e7fa3e89f081fc599fc.png";